import { Component } from '@angular/core';
import { provideValueAccessor } from 'studio-components/shared/value-accessor.utils';
import { FormInputComponent } from '../form-input/form-input.component';

@Component({
  selector: 'studio-form-password-input',
  templateUrl: './form-password-input.component.html',
  styleUrls: ['../form-input/form-input.component.scss', './form-password-input.component.scss'],
  providers: [provideValueAccessor(() => FormPasswordInputComponent)],
})
export class FormPasswordInputComponent extends FormInputComponent {
  type = 'password';
  toggleIsVisible = false;

  get iconName() {
    return this.type === 'text' ? 'eyeOff' : 'eye';
  }

  public togglePasswordVisibility() {
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  public valueChanged(value) {
    this.toggleIsVisible = Boolean(value);
  }
}
